import type {
  CreatePatientInput,
  UserRepository,
} from "@phurshell/psiapp-frontend-core/domain";
import type { Login } from "./Login";

export type TrackRegistration = (userId: number) => void;

/**
 * Cria a conta do paciente e já entra com ela (mesmo fluxo do psiapp-reactnative-user):
 * o createPatient do core não devolve o token, então o login vem logo em seguida.
 */
export class CreatePatient {
  constructor(
    private readonly userRepo: UserRepository,
    private readonly login: Login,
    private readonly trackRegistration: TrackRegistration,
  ) {}

  async execute(params: CreatePatientInput & { redirectTo?: string }): Promise<any> {
    const { redirectTo: _redirectTo, ...rest } = params;
    // O createUser do core envia multipart/form-data: booleanos viram "true"/"false",
    // e o backend grava "true" como 0. Por isso vão como 1/0 (igual ao "Editar conta").
    const request = {
      ...rest,
      type: "user",
      handicapped: rest.handicapped ? 1 : 0,
      foreigner: rest.foreigner ? 1 : 0,
    } as unknown as CreatePatientInput;
    const user = await this.userRepo.createPatient(request);
    this.trackRegistration(user.id);
    return this.login.execute({ email: params.email, password: params.password });
  }
}
